import { color as d3color } from 'd3-color';
import color from 'client/utils/constants/GDS/js/color';
import { Fill, Stroke, Style } from 'ol/style';
import { pointStyle } from './aoiStyle';
import { createBufferedStyles } from './bufferedStyle';

const errorColorD3 = d3color(color.red);

export const LINESTRING_OUTLINE_DASH = [8, 6];
export const DEFAULT_BUFFER_RADIUS_METRES = 10;

const DEFAULT_STROKE_WIDTH_PX = 2;
const DEFAULT_LINESTRING_BUFFER_WIDTH_PX = 20;
const DEFAULT_FILL_OPACITY = 0.2;

export const errorStroke = new Stroke({
    color: errorColorD3.toString(),
    width: DEFAULT_STROKE_WIDTH_PX,
    lineCap: 'round',
    lineJoin: 'round'
});

export const errorStrokeDashed = new Stroke({
    color: errorColorD3.toString(),
    width: DEFAULT_STROKE_WIDTH_PX,
    lineDash: LINESTRING_OUTLINE_DASH,
    lineCap: 'butt',
    lineJoin: 'round'
});

// Kept as an export for parity with the POC and potential external usage.
// Note: the buffered LineString rendering uses polygon buffering (see `createBufferedStyles`).
export const errorLineStringBufferStroke = new Stroke({
    color: errorColorD3.copy({ opacity: DEFAULT_FILL_OPACITY }).toString(),
    width: DEFAULT_LINESTRING_BUFFER_WIDTH_PX,
    lineCap: 'round',
    lineJoin: 'round'
});

export const errorFill = new Fill({
    color: errorColorD3.copy({ opacity: DEFAULT_FILL_OPACITY }).formatRgb()
});

const getErrorStylesForBuffer = (bufferRadiusMetres = DEFAULT_BUFFER_RADIUS_METRES) => {
    const bufferedLineStringStyles = createBufferedStyles({
        bufferRadiusMetres,
        bufferFill: errorFill,
        bufferBorderStroke: errorStrokeDashed,
        centerStroke: errorStroke,
        // If buffer geometry creation fails (JSTS edge cases), fall back to dashed stroke.
        fallbackBufferStroke: errorStrokeDashed
    });

    const styles = {
        draw: {
            Point: pointStyle,
            LineString: bufferedLineStringStyles,
            MultiLineString: bufferedLineStringStyles,
            Polygon: new Style({
                fill: errorFill
            }),
            Circle: new Style({
                fill: errorFill,
                stroke: errorStroke
            })
        },
        modify: {
            Point: pointStyle,
            LineString: bufferedLineStringStyles,
            MultiLineString: bufferedLineStringStyles,
            Polygon: new Style({
                fill: errorFill,
                stroke: errorStroke
            }),
            Circle: new Style({
                fill: errorFill,
                stroke: errorStroke
            })
        }
    };
    return styles;
};

export const getErrorDrawStyle = (bufferRadiusMetres) => getErrorStylesForBuffer(bufferRadiusMetres).draw;
export const getErrorModifyStyle = (bufferRadiusMetres) => getErrorStylesForBuffer(bufferRadiusMetres).modify;

export const errorDrawStyle = getErrorDrawStyle();
export const errorModifyStyle = getErrorModifyStyle();
